// Navigation
export const GET_SECTIONS = "GET_SECTIONS";
export const GET_SECTIONS_SUCCESS = "GET_SECTIONS_SUCCESS";
export const GET_SECTIONS_ERROR = "GET_SECTIONS_ERROR";
export const SET_SECTION = "SET_SECTION";
export const GET_SECTION = "GET_SECTION";
export const GET_SECTION_SUCCESS = "GET_SECTION_SUCCESS";
export const GET_SECTION_ERROR = "GET_SECTION_ERROR";
export const SET_LAST_SEEN = "SET_LAST_SEEN";

export const GET_SPECIAL_FEATURES = "GET_SPECIAL_FEATURES";
export const GET_SPECIAL_FEATURES_SUCCESS = "GET_SPECIAL_FEATURES_SUCCESS";
export const GET_SPECIAL_FEATURES_ERROR = "GET_SPECIAL_FEATURES_ERROR";

// Tag
export const GET_TAG = "GET_TAG";
export const GET_TAG_ERROR = "GET_TAG_ERROR";

// Auth Drawer
export const AUTH_DRAWER_OPEN = "AUTH_DRAWER_OPEN";
export const CHANGE_STEP = "CHANGE_STEP";

export const EMAIL_NOT_AVAILABLE = "EMAIL_NOT_AVAILABLE";
export const EMAIL_AVAILABLE = "EMAIL_AVAILABLE";
export const EMAIL_VALIDATION_REQUEST_ERROR = "EMAIL_VALIDATION_REQUEST_ERROR";

export const EMAIL_CONFIRM_SUCCESS = "EMAIL_CONFIRM_SUCCESS";
export const EMAIL_CONFIRM_ERROR = "EMAIL_CONFIRM_ERROR";

export const SET_BASIC_INFO = "SET_BASIC_INFO";
export const SET_OPTIONAL_INFO = "SET_OPTIONAL_INFO";

export const CREATE_USER_SUCCESS = "CREATE_USER_SUCCESS";
export const CREATE_USER_ERROR = "CREATE_USER_ERROR";

export const PASSWORD_RESET_REQUEST_SUCCESS = "PASSWORD_RESET_REQUEST_SUCCESS";
export const PASSWORD_RESET_REQUEST_ERROR = "PASSWORD_RESET_REQUEST_ERROR";
export const SET_PASSWORD_RESET_INFO = "SET_PASSWORD_RESET_INFO";
export const PASSWORD_RESET_SUCCESS = "PASSWORD_RESET_SUCCESS";
export const PASSWORD_RESET_ERROR = "PASSWORD_RESET_ERROR";

export const SET_AUTH_TOKEN = "SET_AUTH_TOKEN";
export const LOG_OUT = "LOG_OUT";

export const LOGGED_IN_STATUS = "LOGGED_IN_STATUS";

// Latest
export const GET_LATEST_STORIES = "GET_LATEST_STORIES";
export const GET_LATEST_STORIES_SUCCESS = "GET_LATEST_STORIES_SUCCESS";
export const GET_LATEST_STORIES_ERROR = "GET_LATEST_STORIES_ERROR";

// Stream
export const GET_STORIES_STREAM = "GET_STORIES_STREAM";
export const GET_STORIES_STREAM_SUCCESS = "GET_STORIES_STREAM_SUCCESS";
export const GET_STORIES_STREAM_UPDATE = "GET_STORIES_STREAM_UPDATE";
export const GET_STORIES_STREAM_ERROR = "GET_STORIES_STREAM_ERROR";
export const RESET_STORIES_STREAM_ERROR = "RESET_STORIES_STREAM_ERROR";
export const SET_STORY_STREAM = "SET_STORY_STREAM";

// Story
export const GET_STORY = "GET_STORY";
export const GET_STORY_SUCCESS = "GET_STORY_SUCCESS";
export const GET_STORY_UPDATE = "GET_STORY_UPDATE";
export const GET_STORY_ERROR = "GET_STORY_ERROR";

// Author
export const GET_AUTHOR = "GET_AUTHOR";
export const GET_AUTHOR_SUCCESS = "GET_AUTHOR_SUCCESS";
export const GET_AUTHOR_ERROR = "GET_AUTHOR_ERROR";

// Subscription
export const GET_SUBSCRIPTION = "GET_SUBSCRIPTION";
export const GET_SUBSCRIPTION_SUCCESS = "GET_SUBSCRIPTION_SUCCESS";
export const GET_SUBSCRIPTION_ERROR = "GET_SUBSCRIPTION_ERROR";

// Subscriptions
export const GET_SUBSCRIPTIONS = "GET_SUBSCRIPTIONS";
export const GET_SUBSCRIPTIONS_SUCCESS = "GET_SUBSCRIPTIONS_SUCCESS";
export const GET_SUBSCRIPTIONS_ERROR = "GET_SUBSCRIPTIONS_ERROR";

// Subscription Newsletters
export const GET_SUBSCRIPTION_NEWSLETTERS = "GET_SUBSCRIPTION_NEWSLETTERS";
export const GET_SUBSCRIPTION_NEWSLETTERS_SUCCESS =
  "GET_SUBSCRIPTION_NEWSLETTERS_SUCCESS";
export const GET_SUBSCRIPTION_NEWSLETTERS_ERROR =
  "GET_SUBSCRIPTION_NEWSLETTERS_ERROR";

// Newsletter
export const GET_NEWSLETTER = "GET_NEWSLETTER";
export const GET_NEWSLETTER_SUCCESS = "GET_NEWSLETTER_SUCCESS";
export const GET_NEWSLETTER_ERROR = "GET_NEWSLETTER_ERROR";

// Newsletters
export const GET_NEWSLETTERS = "GET_NEWSLETTERS";
export const GET_NEWSLETTERS_SUCCESS = "GET_NEWSLETTERS_SUCCESS";
export const GET_NEWSLETTERS_ERROR = "GET_NEWSLETTERS_ERROR";

// User Settings
export const GET_USER_DATA = "GET_USER_DATA";
export const GET_USER_DATA_SUCCESS = "GET_USER_DATA_SUCCESS";
export const GET_USER_DATA_ERROR = "GET_USER_DATA_ERROR";

export const TYPING_USER_SETTINGS = "TYPING_USER_SETTINGS";
export const SUBMIT_USER_SETTINGS = "SUBMIT_USER_SETTINGS";
export const SUBMIT_USER_SETTINGS_SUCCESS = "SUBMIT_USER_SETTINGS_SUCCESS";
export const SUBMIT_USER_SETTINGS_ERROR = "SUBMIT_USER_SETTINGS_ERROR";

export const GET_USER_SUBSCRIPTIONS = "GET_USER_SUBSCRIPTIONS";
export const GET_USER_SUBSCRIPTIONS_SUCCESS = "GET_USER_SUBSCRIPTIONS_SUCCESS";
export const GET_USER_SUBSCRIPTIONS_ERROR = "GET_USER_SUBSCRIPTIONS_ERROR";
export const CHANGE_USER_SUBSCRIPTIONS = "CHANGE_USER_SUBSCRIPTIONS";
export const SUBMIT_USER_SUBSCRIPTIONS = "SUBMIT_USER_SUBSCRIPTIONS";
export const SUBMIT_USER_SUBSCRIPTIONS_SUCCESS =
  "SUBMIT_USER_SUBSCRIPTIONS_SUCCESS";
export const SUBMIT_USER_SUBSCRIPTIONS_ERROR =
  "SUBMIT_USER_SUBSCRIPTIONS_ERROR";

export const SUBMIT_USER_SAVED_STORIES = "SUBMIT_USER_SAVED_STORIES";
export const SUBMIT_USER_SAVED_STORIES_SUCCESS =
  "SUBMIT_USER_SAVED_STORIES_SUCCESS";
export const SUBMIT_USER_SAVED_STORIES_ERROR =
  "SUBMIT_USER_SAVED_STORIES_ERROR";

export const SAVE_STORY = "SAVE_STORY";
export const SAVE_STORY_SUCCESS = "SAVE_STORY_SUCCESS";
export const SAVE_STORY_ERROR = "SAVE_STORY_ERROR";

export const GET_SAVED_STORIES = "GET_SAVED_STORIES";
export const GET_SAVED_STORIES_SUCCESS = "GET_SAVED_STORIES_SUCCESS";
export const GET_SAVED_STORIES_ERROR = "GET_SAVED_STORIES_ERROR";

export const UNSAVE_STORY = "UNSAVE_STORY";
export const UNSAVE_STORY_SUCCESS = "UNSAVE_STORY_SUCCESS";
export const UNSAVE_STORY_ERROR = "UNSAVE_STORY_ERROR";

export const DELETE_ACCOUNT = "DELETE_ACCOUNT";
export const DELETE_ACCOUNT_SUCCESS = "DELETE_ACCOUNT_SUCCESS";
export const DELETE_ACCOUNT_ERROR = "DELETE_ACCOUNT_ERROR";

export const CHANGE_PASSWORD = "CHANGE_PASSWORD";
export const CHANGE_PASSWORD_SUCCESS = "CHANGE_PASSWORD_SUCCESS";
export const CHANGE_PASSWORD_ERROR = "CHANGE_PASSWORD_ERROR";

// Unauthed Subscriptions
export const SET_UNAUTHED_SUBSCRIPTIONS = "SET_UNAUTHED_SUBSCRIPTIONS";
export const SET_UNAUTHED_SUBSCRIPTIONS_SUCCESS =
  "SET_UNAUTHED_SUBSCRIPTIONS_SUCCESS";
export const SET_UNAUTHED_SUBSCRIPTIONS_ERROR =
  "SET_UNAUTHED_SUBSCRIPTIONS_ERROR";

// User Subscriptions
export const UPDATE_USER_SUBSCRIPTIONS = "UPDATE_USER_SUBSCRIPTIONS";
export const UPDATE_USER_SUBSCRIPTIONS_SUCCESS =
  "UPDATE_USER_SUBSCRIPTIONS_SUCCESS";
export const UPDATE_USER_SUBSCRIPTIONS_ERROR =
  "UPDATE_USER_SUBSCRIPTIONS_ERROR";

// Events
export const GET_EVENTS = "GET_EVENTS";
export const GET_EVENTS_SUCCESS = "GET_EVENTS_SUCCESS";
export const GET_EVENTS_ERROR = "GET_EVENTS_ERROR";
